import axios from 'axios';

import buildPaginationQueryOpts from '@/shared/sort/sorts';

import { IClientRate } from '@/shared/model/client-rate.model';
import { Rates } from '@/shared/model/rate.model';

const baseApiUrl = 'api/client-rates';

export default class ClientRateService {
  public find(id: string): Promise<IClientRate> {
    return new Promise<IClientRate>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/${id}`)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public retrieve(paginationQuery?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseApiUrl + `?${buildPaginationQueryOpts(paginationQuery)}`)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public delete(id: string): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .delete(`${baseApiUrl}/${id}`)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public create(entity: IClientRate): Promise<IClientRate> {
    return new Promise<IClientRate>((resolve, reject) => {
      axios
        .post(`${baseApiUrl}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public update(entity: IClientRate): Promise<IClientRate> {
    return new Promise<IClientRate>((resolve, reject) => {
      axios
        .put(`${baseApiUrl}/${entity.id}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public partialUpdate(entity: IClientRate): Promise<IClientRate> {
    return new Promise<IClientRate>((resolve, reject) => {
      axios
        .patch(`${baseApiUrl}/${entity.id}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public retrieveClientRates(): Promise<Rates> {
    return new Promise<Rates>((resolve, reject) => {
      axios
        .get(baseApiUrl + '/rates')
        .then(res => {
          resolve(Rates.from(res.data));
        })
        .catch(err => {
          reject(err);
        });
    });
  }
}
